<script>
import MottoIcon from './motto-icon.vue'

export default {
  components: { MottoIcon },
  inheritAttrs: false,
  props: {
    target: {
      type: String,
      required: true,
    },
    placement: {
      type: String,
      required: true,
    },
    customClass: {
      type: String,
      default: '',
    },
    theme: {
      type: String,
      default: 'gray',
    },
    iconName: {
      type: String,
      default: 'Help',
    },
    iconColor: {
      type: String,
      default: 'gray',
    },
    iconHide: {
      type: Boolean,
      default: false,
    },
    iconAbsolutePosition: {
      type: Boolean,
      default: true,
    },
    boundary: {
      type: String,
      default: '',
    },
    triggers: {
      type: String,
      default: 'hover focus',
    },
  },
  computed: {
    tooltipClasses() {
      let classes = []
      if (this.theme === 'blue') {
        classes = ['tooltipBlue']
      }

      if (this.theme === 'gray') {
        classes = ['tooltipGray']
      }

      if (this.theme === 'orange') {
        classes = ['tooltipOrange']
      }

      if (this.theme === 'green') {
        classes = ['tooltipGreen']
      }

      if (this.customClass) {
        classes = [...classes, this.customClass]
      }

      return classes.join(' ')
    },
  },
}
</script>

<template>
  <span :class="[$style.tooltipContainer, triggers.includes('click') ? $style.clickable : '']">
    <MottoIcon
      v-if="!iconHide"
      :id="target"
      data-tooltip-icon
      :class="{ [$style.iconAbsolutePosition]: iconAbsolutePosition }"
      :name="iconName"
      :icon-color="iconColor"></MottoIcon>
    <b-tooltip
      :target="target"
      :placement="placement"
      :triggers="triggers"
      v-bind="boundary ? { boundary } : {}"
      :custom-class="tooltipClasses">
      <slot />
    </b-tooltip>
  </span>
</template>

<style lang="scss">
@import '@design';
</style>

<style lang="scss" module>
@import '@design';

.tooltipContainer {
  svg {
    width: 20px;
  }
}

.clickable {
  cursor: pointer;
}

.iconAbsolutePosition {
  position: absolute;
  top: 10px;
  right: 18px;
}
</style>
